<template>
  <div class="animated fadeIn">
    <div class="form-group row">
      <div class="col-md-12">
        <b-form-textarea id="txtDetalhes"
                    name="txtDetalhes"
                    v-model="form.detalhes.value"
                    :placeholder="'Digite as observações aqui'"
                    :rows="form.detalhes.rows"
                    :size="form.detalhes.maxlength"
                    :noResize="form.detalhes.noResize"
                    :disabled="!cardActive"></b-form-textarea>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-third btn-sm rounded"
      v-on:click="onSave"
      v-if="cardActive"
      v-b-tooltip.hover
      :title="$lang.Common.Tooltip.ButtonSave"
      >
      <i class="fa fa-check-circle"></i> <span class="d-md-down-none">{{ $lang.Common.Buttons.Save }}</span>
    </button>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import ObservationForm from './observation-form.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'

export default {
  name: 'CrmDetailsObservation',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    cardActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: ObservationForm
    }
  },
  methods: {
    onLoad () {
      this.form.detalhes.value = this.card.observacao
    },
    onSave () {
      loading.push()
      CardRepository.PatchObservation({id: this.card.id, observacao: this.form.detalhes.value})
        .then(res => {
          loading.pop()
          if (res.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
          }
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/observation/observation.vue